import {
  registerReactComponent
} from '@trp-beacon-ui-kit/foundation/react/register';
import {
  BeaconInputField
} from '@trp-beacon-ui-kit/foundation/components/beacon-input-field';
// This is the name of your project, library, application, etc. - make sure to use a specific prefix
const projectNamePrefix = 'rmd';

//This is your React component that can be used in the return/render block below
export const RMDBeaconInputField = registerReactComponent(
  projectNamePrefix,
  BeaconInputField
);
